module.exports = __webpack_public_path__ + "media/images/flags/ER-11cf53afbfbe68c9e4fcd98b5dc04ace.svg";